export default __webpack_public_path__ + "static/Poppins-Bold-e2abc8f5e9a67ea669ea33339d2bc83a.ttf";